import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { LabeledSelect } from '../../../../generic';
import BinaryMatchDetailsContent from '../../modals/BinaryMatchDetailsModal/BinaryMatchDetailsContent';
import type { Dependency } from '../../../../../../shared/dependenciesV2';
import type { SelectOption } from '../../../../../types';

type Props = {
  dependency: Dependency;
};

const DependencyMatchDetails: VoidFunctionComponent<Props> = ({ dependency }) => {
  // We know that there will always be at least one root project.
  const [originProjectRevision, setOriginProjectRevision] = useState<SelectOption>(
    { label: dependency.rootProjects[0]?.title, value: dependency.rootProjects[0]?.revision },
  );

  return (
    <div>
      {dependency.rootProjects.length > 1 && (
        <LabeledSelect
          variant="legacy"
          label="Root Project"
          options={dependency.rootProjects.map((project) => ({
            label: project.title,
            value: project.revision,
          }))}
          value={originProjectRevision}
          onChange={(value) => setOriginProjectRevision(value as SelectOption)}
          id="origin-project-revision"
        />
      )}
      <BinaryMatchDetailsContent projectRevision={originProjectRevision.value} revision={dependency.locator} />
    </div>
  );
};

export default DependencyMatchDetails;
